"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Marquee = _interopRequireDefault(require("./Marquee"));

var _jsxFileName = "E:\\720\\720yun_player\\packages\\pano-marquee\\src\\MarqueeController.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var MarqueeController = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MarqueeController, _React$PureComponent);

  function MarqueeController() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = MarqueeController.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        text = _this$props.text,
        fontSize = _this$props.fontSize,
        maxWidth = _this$props.maxWidth,
        disable = _this$props.disable,
        align = _this$props.align,
        disableColor = _this$props.disableColor,
        color = _this$props.color,
        _this$props$mouseEnte = _this$props.mouseEnterPause,
        mouseEnterPause = _this$props$mouseEnte === void 0 ? true : _this$props$mouseEnte;
    if (!text) return null;
    return /*#__PURE__*/_react["default"].createElement(_Marquee["default"], {
      disableColor: disableColor,
      maxWidth: maxWidth,
      text: text,
      fontSize: fontSize,
      align: align,
      disable: disable,
      color: color,
      mouseEnterPause: mouseEnterPause,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9,
        columnNumber: 7
      }
    });
  };

  return MarqueeController;
}(_react["default"].PureComponent);

var _default = MarqueeController;
exports["default"] = _default;
module.exports = exports.default;